module.exports = __webpack_public_path__ + "797bcd86f3ed9b7d70f260c9bc27b26f.eot";


//////////////////
// WEBPACK FOOTER
// ./src/style/fonts/GT-Walsheim-Pro-Bold.eot
// module id = 398
// module chunks = 0